import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import SetPasswordPage from './pages/SetPasswordPage'
import Profile from './pages/Profile'
import Activity from './pages/Activity'
import Groups from './pages/Groups'
import GroupDetail from './pages/GroupDetail'
import Resources from './pages/Resources'
import Broadcasters from './pages/Broadcasters'
import BroadcasterGroups from './pages/BroadcasterGroups'
import ADCreators from './pages/ADCreators'
import ADCreatorGroups from './pages/ADCreatorGroups'
import Search from './pages/Search'
import Moderation from './pages/Moderation'
import Uploads from './pages/Uploads'
import ListingsSyncPage from './pages/ListingsSyncPage'
import AdminChannelControlPage from './pages/AdminChannelControlPage'
import AdminLanguageControlPage from './pages/AdminLanguageControlPage'
import AdminInvitesPage from './pages/AdminInvitesPage'
import AdminUsersPage from './pages/AdminUsersPage'
import AdminAnnouncementsPage from './pages/AdminAnnouncementsPage'
import AdminDashboardPage from './pages/AdminDashboardPage'
import AdminPlaceholderPage from './pages/AdminPlaceholderPage'
import AdminUsagePage from './pages/AdminUsagePage'
import AdminAccessibilityPage from './pages/AdminAccessibilityPage'
import AdminListingsHealthPage from './pages/AdminListingsHealthPage'
import AdminListingsReportPage from './pages/AdminListingsReportPage'
import AdminListingsManagementPage from './pages/AdminListingsManagementPage'
import AdminAccessibilityUploadPage from './pages/AdminAccessibilityUploadPage'
import AdminStreamingControlPage from './pages/AdminStreamingControlPage'
import AdminStreamingCataloguePage from './pages/AdminStreamingCataloguePage'
import AdminStreamingReportPage from './pages/AdminStreamingReportPage'
import AdminAuditPage from './pages/AdminAuditPage'
import InviteAcceptPage from './pages/InviteAcceptPage'
import InviteAcceptErrorBoundary from './components/InviteAcceptErrorBoundary'
import AdminFeatureFlagsPage from './pages/AdminFeatureFlagsPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import AboutPage from './pages/AboutPage'
import HelpPage from './pages/HelpPage'
import TvGuide from './pages/TvGuidePage'
import StreamingPage from './pages/StreamingPage'
import Layout from './components/Layout'
import AuthGuard from './components/AuthGuard'
import AdminPortalLayout from './components/AdminPortalLayout'
import HelpLayout from './components/HelpLayout'

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="set-password" element={<SetPasswordPage />} />
            <Route path="invite/accept" element={<InviteAcceptErrorBoundary><InviteAcceptPage /></InviteAcceptErrorBoundary>} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="help" element={<HelpLayout />}>
              <Route index element={<Navigate to="/help/welcome" replace />} />
              <Route path=":sectionId" element={<HelpPage />} />
            </Route>
            <Route
              path="activity"
              element={
                <AuthGuard>
                  <Activity />
                </AuthGuard>
              }
            />
            <Route
              path="groups"
              element={
                <AuthGuard>
                  <Groups />
                </AuthGuard>
              }
            />
            <Route
              path="groups/:id"
              element={
                <AuthGuard>
                  <GroupDetail />
                </AuthGuard>
              }
            />
            <Route
              path="links"
              element={
                <AuthGuard>
                  <Resources />
                </AuthGuard>
              }
            />
            <Route
              path="broadcasters"
              element={
                <AuthGuard>
                  <Broadcasters />
                </AuthGuard>
              }
            />
            <Route
              path="broadcasters/:userId"
              element={
                <AuthGuard>
                  <BroadcasterGroups />
                </AuthGuard>
              }
            />
            <Route
              path="ad-creators"
              element={
                <AuthGuard>
                  <ADCreators />
                </AuthGuard>
              }
            />
            <Route
              path="ad-creators/:userId"
              element={
                <AuthGuard>
                  <ADCreatorGroups />
                </AuthGuard>
              }
            />
            <Route
              path="profile"
              element={
                <AuthGuard>
                  <Profile />
                </AuthGuard>
              }
            />
            <Route
              path="search"
              element={
                <AuthGuard>
                  <Search />
                </AuthGuard>
              }
            />
            <Route
              path="moderation"
              element={
                <AuthGuard>
                  <Navigate to="/admin/moderation" replace />
                </AuthGuard>
              }
            />
            <Route
              path="uploads"
              element={
                <AuthGuard>
                  <Uploads />
                </AuthGuard>
              }
            />
            <Route
              path="admin"
              element={
                <AuthGuard>
                  <AdminPortalLayout />
                </AuthGuard>
              }
            >
              <Route index element={<AdminDashboardPage />} />
              <Route path="usage" element={<AdminUsagePage />} />
              <Route path="accessibility" element={<AdminAccessibilityPage />} />
              <Route path="moderation" element={<Moderation />} />
              <Route path="listings-health" element={<AdminListingsHealthPage />} />
              <Route path="listings-report" element={<AdminListingsReportPage />} />
              <Route path="listings-management" element={<AdminListingsManagementPage />} />
              <Route path="listings-sync" element={<ListingsSyncPage />} />
              <Route path="listings-channels" element={<AdminChannelControlPage />} />
              <Route path="language-control" element={<AdminLanguageControlPage />} />
              <Route path="streaming-control" element={<AdminStreamingControlPage />} />
              <Route path="streaming-report" element={<AdminStreamingReportPage />} />
              <Route path="accessibility-upload" element={<AdminAccessibilityUploadPage />} />
              <Route path="streaming-catalogue" element={<AdminStreamingCataloguePage />} />
              <Route path="invites" element={<AdminInvitesPage />} />
              <Route path="users" element={<AdminUsersPage />} />
              <Route path="announcements" element={<AdminAnnouncementsPage />} />
              <Route path="feature-flags" element={<AdminFeatureFlagsPage />} />
              <Route path="audit" element={<AdminAuditPage />} />
            </Route>
            <Route
              path="tv-guide"
              element={
                <AuthGuard>
                  <TvGuide />
                </AuthGuard>
              }
            />
            <Route
              path="streaming"
              element={
                <AuthGuard>
                  <StreamingPage />
                </AuthGuard>
              }
            />
            {/* Add more routes here as features are built */}
          </Route>
        </Routes>
      </ThemeProvider>
    </AuthProvider>
  )
}

export default App

